<template>
    <div>
        <div class="cover-layer"></div>
        <div class="room-count" ref="hotelStar">
                <ul>
                    <li @click="RoomCount('10')">不限</li>
                    <li @click="RoomCount('0,1')">二星以下</li>
                    <li @click="RoomCount('2')">三星舒适</li>
                    <li @click="RoomCount('3')">四星高档</li>
                    <li @click="RoomCount('5')">五星豪华</li>
                </ul>
            </div>
    </div>
</template>

<script>
    export default {
        name: "hotelStar",
        props:{
            isRoomCountShow:{
                type:Boolean,
                default:false,
            },
        },
        data: function () {
            return {}
        },

        mounted() {
            this.addCloseListener();
        },
        methods: {
            RoomCount(val){
                this.$emit('select',val);
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick,false);
            },
            onClick(e){
                if (e.target.className == 'room-count' || this.$refs.hotelStar && this.$refs.hotelStar.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
    }
</script>

<style scoped>
    .room-count{
        position: absolute;
        top: 48px;
        left: -1px;
        width: 119px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }
    .room-count ul li{
        padding: 0px 10px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
    }
    .room-count ul li:hover{
        color: #fff;
        background: #1270f8;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/hotelStar/hotelStar.vue